<template>
    <div></div>
</template>

<script>
export default {
    name: "AutoLogin",
    methods: {
        parseJwt(token) {
            try {
                var base64Url = token.split('.')[1];
                var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

                return JSON.parse(jsonPayload);
            } catch (e) {
                return null;
            }
        },
        readToken(){
            try {
                var token = localStorage.getItem('rsv_token');
                if(token == null) {
                    token = this.readCookie('rsv_token');
                }
                var raw = token;
                if (token !== null) {
                    token = this.parseJwt(token);
                }
                return {message: "auth", token: token, raw : raw};

            } catch (e) {
                return {message: "error"};
            }
        },
        readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },
        async setTokenInFrame(e) {
            const url = `https://${window.authSub}.${ window.rsvDomain }/api/v1/jwt/validate?jwt=${e}`;
            if (e && e != '') {
                let response = await fetch(url);
                if (response.ok) { // если HTTP-статус в диапазоне 200-299// получаем тело ответа (см. про этот метод ниже)
                    let data = await response.json();
                    if (data.status == 'success') {
                        localStorage.setItem('rsv_token', e);
                        this.socket.send(this.readToken());
                    } else {
                        localStorage.setItem('rsv_token', '');
                        this.socket.send({ message: "redirect to auth" });
                    }
                } else {
                    localStorage.setItem('rsv_token', '');
                    this.socket.send({ message: "redirect to main" });
                }
            }
        },
        xdm(callback) {
            let receiveMessage = async function(event) {
                try {
                    if (event.source === window.parent && event.data.type === 'newToken') {
                        await this.setTokenInFrame(event.data.token);
                    }
                } catch (e) {
                    // console.info('CLIENT: invalid received message');
                    // console.debug(event.data);
                }
                try {
                    if (event.source === window.parent) {
                        callback(JSON.parse(event.data));
                    }
                } catch (e) {
                    // console.info('CLIENT: invalid received message');
                    // console.debug(event.data);
                }
            };

            window.addEventListener("message", receiveMessage, false);

            return {
                send: async function(data) {
                    if (data.message == 'auth') {
                        if (data.raw && data.raw != '') {
                            const url = `https://${window.authSub}.${ window.rsvDomain }/api/v1/jwt/validate?jwt=${data.raw}`;
                            let response = await fetch(url);
                            if (response.ok) {
                                let rs = await response.json();
                                if (rs.status == 'success') {
                                    window.parent.postMessage(JSON.stringify(data), '*');
                                } else {
                                    localStorage.setItem('rsv_token', '');
                                    window.parent.postMessage(JSON.stringify({ message: "redirect to auth" }), '*');
                                }
                            }
                        } else {
                            window.parent.postMessage(JSON.stringify({ message: "not logged in" }), '*');
                        }
                    }
                },
            };
        },
    },
    data() {
        return {
            socket: this.xdm(function () {}),
        };
    },
    mounted() {
        try {
            let token = localStorage.getItem('rsv_token');
            if(token == null) {
                token = this.readCookie('rsv_token');
            }
            let raw = token;
            if (token !== null) {
                token = this.parseJwt(token);
            }
            this.socket.send({message: "auth", token: token, raw : raw});
        } catch (e) {
            this.socket.send({message: "error"});
        }
    },
    created(){
        this.$emit('hideAll');
    },
};
</script>

<style scoped>
    body {
        display: none;
    }
</style>